import React from 'react';
import ChooseComponent from '../ChooseComponent/ChooseComponent';
import * as urlHelper from '../../util/url';
import transLoader from '@beisen/i18n-translation-loader';
import './JumpToSpecify.scss';

const defaultTranslation = {
    errorMessage: '获取$fieldname失败'
};
class JumpToSpecify extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            jumpList: []
        };
        this.handleChange = this.handleChange.bind(this);
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            errorMessage: 'tip.errorMessage'
        }), props.translation);
    }

    componentDidMount() {
        const params = {
            method: 'GET',
            credentials: 'same-origin'

        };
        const failureCallBack = function(res) {
            let errMsg = this.translation.errorMessage.replace('$fieldname', this.props.label);
            this.props.actions.showTip({ message: res.Message || errMsg, type: 'error' });
            this.props.stopLoadForField && this.props.stopLoadForField();
        }.bind(this);

        const successCallBack = function(res) {
            if(res.Code != 200) {
                this.props.actions.showTip({ message: res.Message,type: 'error' });
                this.props.stopLoadForField && this.props.stopLoadForField();
                return;
            }
            //console.log(data,'data');
            const listData = this.formatData(res.Data);
            this.setState({ jumpList: listData },() => {
                this.props.stopLoadForField && this.props.stopLoadForField();
                listData.length == 1 && this.props.onChange && this.props.onChange(listData[0]);
            });
        }.bind(this);
        window.CommonFetch(this.getFetchUrl(), params, successCallBack, failureCallBack, this.props.analysisData);
    }

    formatData(data) {
        return data.map(item => {
            return { text: item.ActivityName, value: item.ActivityId };
        });
    }

    getFetchUrl() {
        return urlHelper.keepHttpsProtocolSame(`/api/v1/WF/ApprovalCentre/GetActivityJumpToActivityList?app=${window.BSGlobal.application}&taskObjectId=${this.props.taskObjectId}`);
    }

    handleChange(obj) {
        this.props.onChange && this.props.onChange(obj);
    }

    renderSingle() {
        return (<div className="jump-single border-1px">
                    <span className="jump-single-title">{this.props.label}</span>
                    <span className="jump-single-text">{this.state.jumpList && this.state.jumpList[0] && this.state.jumpList[0].text}</span>
                </div>);
    }

    render() {
        const { cmp_data, ...others } = this.props;
        const cmpData = Object.assign({},cmp_data,{ datasource: this.state.jumpList });
        return (this.state.jumpList.length > 1 ? <ChooseComponent {...others} cmp_data={cmpData}  onChange={this.handleChange} />
                    : this.renderSingle());
    }
}


export default JumpToSpecify;



// WEBPACK FOOTER //
// ./src/components/Field_Components/JumpToSpecify/JumpToSpecify.js